module.exports = __webpack_public_path__ + "img/collaboration2.3f98914b.png";